var _circle, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _ellipse, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSportsGolfCart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9067 16.0215L60.2991 41.4362L62.4892 40.8486L53.6061 16.0215H50.9067Z",
    fill: "#22262A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.591 37.3394L62.7588 47.6949C63.0494 47.9644 63.1273 48.3933 62.9501 48.7478L62.6772 49.2935C62.4109 49.8261 61.7076 49.9531 61.2718 49.5474L49.8169 38.8825C49.6891 38.7635 49.5292 38.6847 49.357 38.6557L47.1277 38.281C46.8433 38.2332 46.5532 38.3259 46.3492 38.5299L45.3847 39.4944C45.0275 39.8516 44.4454 39.8412 44.1013 39.4715L43.9301 39.2877C43.6093 38.9431 43.6116 38.4084 43.9354 38.0666L50.4213 31.2204C50.7959 30.825 51.4343 30.8548 51.7705 31.2833L51.8582 31.395C52.1109 31.7171 52.1118 32.1699 51.8605 32.4931L51.0221 33.5709C50.866 33.7716 50.803 34.0294 50.8489 34.2795L51.3202 36.8464C51.3549 37.0356 51.4499 37.2085 51.591 37.3394Z",
    fill: "#22262A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.302 35.3085C34.3757 38.7949 40.0445 42.4928 32.4162 42.4928C30.8533 42.9741 28.7159 40.5379 27.6422 37.0515C26.5685 33.565 22.9172 30.4698 28.528 29.8672C30.0909 29.3859 32.2283 31.822 33.302 35.3085Z",
    fill: "#8BA2C0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.9731,
    y: 40.4147,
    width: 16.5748,
    height: 6.62992,
    rx: 3.31496,
    fill: "#8BA2C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5272 29.4513C21.0738 27.9935 21.666 19.8849 21.8938 16.0128H26.3815V27.1736C26.3815 34.0978 31.3925 42.2065 33.898 45.3953C29.5703 45.0916 18.6139 44.302 18.2495 43.5731C17.7939 42.662 19.8439 31.2734 20.5272 29.4513Z",
    fill: "#22262A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1376 43.5255C11.6799 44.801 11.3154 47.5494 11.3154 48.7642L23.3873 51.0419L31.3593 58.7862H43.7945V45.6477L17.693 41.5543C16.7819 41.3265 14.5953 42.25 13.1376 43.5255Z",
    fill: "#F1AE5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6196 48.8119C57.9603 43.483 58.0516 42.233 58.8846 39.1936C58.996 38.7872 59.3811 38.5144 59.7994 38.5653C67.0713 39.4515 69.47 45.7228 70.6468 48.8119H56.6196Z",
    fill: "#F1AE5B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7652 18.5615C20.1914 16.4881 22.0165 15 24.1332 15H51.5281C53.336 15 54.9651 16.0916 55.6525 17.7638L56.5301 19.8986C56.7714 20.4855 56.3399 21.1296 55.7052 21.1296H20.3312C19.7664 21.1296 19.3438 20.6113 19.4575 20.0581L19.7652 18.5615Z",
    fill: "#F1AE5B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6989 57.6948H8.89187C8.39931 57.6948 7.99774 57.2947 8.02168 56.8027C8.2443 52.2273 10.1292 48.8285 11.2398 47.7539C11.352 47.6453 11.4976 47.5831 11.6522 47.562C12.3105 47.4724 12.3042 47.5971 20.8907 47.5971C26.5342 47.5971 30.8134 51.3508 32.1432 54.4469C32.2975 54.8062 32.6381 55.0632 33.0291 55.0632H54.2077C54.629 55.0632 54.9928 54.7685 55.0802 54.3564L56.3641 48.3039C56.4515 47.8918 56.8122 47.5971 57.2335 47.5971H70.3171C74.6448 47.5971 76.9515 55.8636 74.9143 55.8636C72.9575 55.8636 69.7026 58.4176 66.7415 58.4176C60.7953 58.4176 59.2337 57.6573 58.1266 60.0774C57.9708 60.4179 57.6423 60.6559 57.2679 60.6559H30.2312C29.7673 60.6559 29.3841 60.2989 29.3188 59.8397C28.6003 54.7863 25.208 51.0895 19.8441 51.0895C14.7596 51.0895 13.1824 54.7187 12.5858 56.9941C12.4791 57.4009 12.1195 57.6948 11.6989 57.6948Z",
    fill: "#22262A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7078,
    cy: 59.752,
    rx: 9.39239,
    ry: 9.39239,
    fill: "#505862"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.7077,
    cy: 59.752,
    r: 5.83851,
    fill: "#B9BEC6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8624,
    cy: 59.4974,
    r: 9.13779,
    fill: "#505862"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8624,
    cy: 59.4974,
    r: 5.68025,
    fill: "#B9BEC6"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSportsGolfCart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SportsGolfCart.4cf1839dbc7e1c6e48486ae8949c73cf.svg";